/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * TWO_READS: two actual reads per register (read-to-read); KNOWN_READ_PLUS_EAC_AQ: one known read plus the account's EAC/AQ per register
 */
export type EstimateMeterReadRequestMode =
  (typeof EstimateMeterReadRequestMode)[keyof typeof EstimateMeterReadRequestMode]

export const EstimateMeterReadRequestMode = {
  TWO_READS: "TWO_READS",
  KNOWN_READ_PLUS_EAC_AQ: "KNOWN_READ_PLUS_EAC_AQ",
} as const
